import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import styles from './NewThem.module.scss';
import { FormikProvider, useFormik } from 'formik';
import ThemForm from './theme-form/ThemForm';
import ThemeScale from './theme-scale/ThemeScale';
import * as Yup from 'yup';
import { settingsEndpoints } from 'hooks/endpoints';
import { usePost } from 'hooks/usePost';
import { useParams } from 'react-router-dom';

const validationSchema = Yup.object().shape({
  responseName: Yup.string().required('Required'),
  description: Yup.string()
    .max(500, 'Description cannot exceed 500 characters')
    .required('Required'),
  tags: Yup.string().required('Required'),
  exampleResponse: Yup.string().required('Required'),
  temperature: Yup.number()
    .min(0)
    .max(1, 'Temperature must be between 0 and 1')
    .required('Required'),
  nucleusSamplingFactor: Yup.number()
    .min(0)
    .max(1, 'Nucleus Sampling Factor must be between 0 and 1')
    .required('Required'),
  maxTokenResponse: Yup.number()
    .min(0)
    .max(1000, 'Max Token Response must be between 0 and 1000')
    .required('Required'),
  stopSequence: Yup.string(),
  frequencyPenalty: Yup.number()
    .min(0)
    .max(2, 'Frequency Penalty must be between 0 and 2')
    .required('Required'),
  presencePenalty: Yup.number()
    .min(0)
    .max(2, 'Presence Penalty must be between 0 and 2')
    .required('Required'),
});

const NewTheme = forwardRef(({ setMode, setActiveTab, submitTheme }, ref) => {
  const { id } = useParams();
  const formik = useFormik({
    initialValues: {
      responseName: '',
      description: '',
      tags: '',
      exampleResponse: '',
      temperature: 0,
      nucleusSamplingFactor: 0,
      maxTokenResponse: 0,
      stopSequence: '',
      frequencyPenalty: 0,
      presencePenalty: 0,
      botId: id,
    },
    validationSchema: validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      // submitTheme(
      //   {
      //     data: values,
      //     url: settingsEndpoints.postResponseTheme(),
      //   },
      //   {
      //     onSuccess: () => {
      //       setMode(null);
      //       setActiveTab(1);
      //     },
      //   }
      // );
    },
  });

  useImperativeHandle(ref, () => ({
    submitForm: () => formik.submitForm(),
  }));

  useEffect(() => {
    ref.current = formik;
  }, [ref, formik]);

  return (
    <FormikProvider value={formik} innerRef={ref}>
      <div ref={ref} className={styles.container}>
        <ThemForm />
        <ThemeScale />
      </div>
    </FormikProvider>
  );
});

export default NewTheme;
